import { Observable } from 'rxjs/Observable';
import { InternalService } from './../../services/internal.service';
import { UbigeoService } from './../../services/ubigeo.service';
import { WaybillService } from './../../services/waybill.service';
import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef,MatDialog } from '@angular/material';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { BudgetService } from '../../services/budget.service';
import { NgForm } from '@angular/forms';
import {FormControl} from '@angular/forms';
import * as uuid from 'uuid';
import { ProviderService } from '../../services/provider.service';
import { Router, ActivatedRoute } from '@angular/router';
import {map, startWith} from 'rxjs/operators';

@Component({
    selector: 'app-new-waybill',
    templateUrl: 'newWaybillModal.component.html',
    styleUrls: ['./newWaybillModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [BudgetService, ProviderService, WaybillService,UbigeoService]
})
export class NewWaybillModalComponent implements OnDestroy {
    modalTitle = 'NUEVA GUIA DE REMISION';
    buttonText = '';
    waybillData:any = {};
    punto_llegada = new FormControl();
    punto_partida= new FormControl();
    subscription: Subscription;
    action: string;
    ubigeoFilter:string;
    listProducts: IProduct[] = [];
    localidades : ILocalidad[];
    product: IProduct={descripcion: '',cantidad:0};
    partidaFilter: Observable<ILocalidad[]>;
    llegadaFilter: Observable<ILocalidad[]>;
    ubigeo_punto_partida: string;
    ubigeo_punto_llegada: string;
    editMode=false;
    constructor(public dialogRef: MatDialogRef<NewWaybillModalComponent>,
        private dialog: MatDialog,
        private notifierService: NotifierService,
        private waybillService: WaybillService,
        private ubigeoService: UbigeoService,
        private zone: NgZone,
        private routes: Router,
        private internalService: InternalService) {

        this.internalService.internalListener.subscribe(
                (result: any) => {
                    this.waybillData.nro_guia=result.numGuide;
                    console.log('res',result)
                    if(result.message){
                        let data={
                            id:result.message.id,
                            tipo_guia:'1',
                            motivo_id:result.message.dispatch_reason,
                            nro_guia:result.message.number_guide,
                            nro_ruc:result.message.destination_ruc,
                            denominacion:result.message.destination_denomination,
                            direccion:result.message.destination_address,
                            inicio_translado:result.message.start_dispatch_date.slice(0,10),
                            tipo_transporte:result.message.transport_type,
                            ubigeo_punto_partida:result.message.dispatch_point_ubigeo,
                            punto_partida:result.message.dispatch_point,
                            ubigeo_punto_llegada:result.message.arrival_point_ubigeo,
                            punto_llegada:result.message.arrival_point,
                            tipo_doc_transportista:result.message.document_type_transport,
                            doc_transportista:result.message.document_transport,
                            descripcion_transportista:result.message.transport_description,
                            placa:result.message.license,
                            tipo_doc_conductor:result.message.document_type_driver,
                            doc_conductor:result.message.document_driver,
                            nombre_conductor:result.message.drive_name
                        }

                        this.ubigeo_punto_partida=result.message.dispatch_point_ubigeo_descrip
                        this.ubigeo_punto_llegada=result.message.arrival_point_ubigeo_descrip
                        let listAux=result.message.listProducts as any[];
                        listAux.forEach(item=>{
                            item.cantidad=item.quantity
                            item.descripcion= item.description
                        })

                        this.waybillData=data
                        this.listProducts=result.message.listProducts
                        this.editMode=true
                    }
                    console.log('way:',this.waybillData,'prod:',this.listProducts)
                }
            )

        this.ubigeoService.getUbigeoList(this.ubigeoFilter)
            .subscribe(
                result => {
                    this.localidades = result as Array<any>
                    this.partidaFilter = this.punto_partida.valueChanges
                        .pipe(
                            startWith(''),
                            map(value => this._filter(value))
                        );
                    
                    this.llegadaFilter = this.punto_llegada.valueChanges
                        .pipe(
                            startWith(''),
                            map(value => this._filter(value))
                        );
                },
                error => {
                    console.log('error', error);
                }
            )
    }

    private _filter(value): ILocalidad[] {
        const filterValue = value.toLowerCase();
    
        return this.localidades.filter(option => option.descripcion.toLowerCase().includes(filterValue));
      }

    verify(){
        if(this.waybillData.tipo_doc_transportista==6 && this.waybillData.doc_transportista.length<11){
            return false
        }

        if(this.waybillData.tipo_doc_transportista==1 && this.waybillData.doc_transportista.length<8){
            return false
        }

        if(this.waybillData.tipo_doc_conductor==6 && this.waybillData.doc_conductor.length<11){
            return false
        }

        if(this.waybillData.tipo_doc_conductor==1 && this.waybillData.doc_conductor.length<8){
            return false
        }

        if(this.waybillData.nro_ruc.length<11){
            return false
        }
        return true;
    }

    /**
     * 
     * update(form: NgForm) {
        if (form.valid) {
            if (this.budgetItem.provider_id) {
                const found = this.providers.find((item) => {
                    // tslint:disable-next-line:triple-equals
                    return item.id == this.budgetItem.provider_id;
                });
                this.budgetItem.provider_name = found.comercial_name;
            }
            if (this.budgetItem.id) {
                this.budgetItem.action_backend = 'U';
            } else {
                this.budgetItem.action_backend = 'C';
            }
            this.dialogRef.close(this.budgetItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }
     */

    create(form: NgForm) {
        if (form.valid && this.listProducts.length>0) {
            if(this.verify()){
                this.waybillData.listItems=this.listProducts

                console.log('waybill',this.waybillData)
                console.log('form',form)
                
                this.waybillService.createWaybill(this.waybillData).subscribe(
                    result => {
                        console.log(result)
                        this.notifierService.systemNotify({
                            title: 'Exito',
                            message: 'Guia creada correctamente.',
                            duration: 4000,
                            type: 'success'
                        });
                        this.dialogRef.close();
                        //this.routes.navigate(['/system/waybill/list']);
                    },
                    error =>{
                        console.log(error);
                        this.notifierService.systemNotify({
                        title: 'Error',
                        message: error.error.message,
                        type: 'error',
                        duration: 5000,
                        });
                    });
                 
            }else{
                this.notifierService.systemNotify({
                    title: 'Ha ocurrido un error',
                    message: 'Revise nuevamente los documentos',
                    type: 'error'
                });
            }
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete todos los campos',
                type: 'error'
            });
        }
    }

    edit(form: NgForm){
        if (form.valid && this.listProducts.length>0) {
            if(this.verify()){
                this.waybillData.listItems=this.listProducts

                console.log('waybill',this.waybillData)
                console.log('form',form)
                
                this.waybillService.editWaybill(this.waybillData).subscribe(
                    result => {
                        console.log(result)
                        this.notifierService.systemNotify({
                            title: 'Exito',
                            message: 'Guia editada correctamente.',
                            duration: 4000,
                            type: 'success'
                        });
                        this.dialog.closeAll();
                        //this.routes.navigate(['/system/waybill/list']);
                    },
                    error =>{
                        console.log(error);
                        this.notifierService.systemNotify({
                        title: 'Error',
                        message: error.error.message,
                        type: 'error',
                        duration: 5000,
                        });
                    });
                 
            }else{
                this.notifierService.systemNotify({
                    title: 'Ha ocurrido un error',
                    message: 'Revise nuevamente los documentos',
                    type: 'error'
                });
            }
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete todos los campos',
                type: 'error'
            });
        }
    }

    duplicateVerify(array, key) {

        var length = array.length;
        var found = false;
        for (var i = 0; i < length; i++) {
          if (key.descripcion == array[i].descripcion) {
            found = true;
            break;
          }
        }
    
        return found;
    }

    getUbigeo(event?) {
        console.log(this.localidades)
        if(event) {
            this.ubigeoFilter = event.target.value
        }
        this.ubigeoService.getUbigeoList(this.ubigeoFilter)
            .subscribe(
                result => {
                    this.localidades = result as Array<any>
                },
                error => {
                    console.log('error', error);
                }
            ) 
    }

    onUbigeoPartidaSelected(localidad){
        this.waybillData.ubigeo_punto_partida=localidad.ubigeo
    }

    onUbigeoLlegadaSelected(localidad){
        this.waybillData.ubigeo_punto_llegada=localidad.ubigeo
    }

    addProduct(){
        if (!this.duplicateVerify(this.listProducts, this.product)) {

            this.listProducts.push(this.product);
            console.log('añadido')
      
        } 
        console.log('products',this.listProducts)
        this.product = {descripcion: '',cantidad:0};
    }

    deleteProduct(index) {
        this.listProducts.splice(index, 1);
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
export interface IProduct {
    descripcion?: string;
    cantidad?: number;
}

export interface ILocalidad {
    descripcion?:string;
    ubigeo?:number;
}


// WEBPACK FOOTER //
// ./src/app/system/waybill/new-waybill/newWaybillModal.component.ts